
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("knzfV", function(module, exports) {

$parcel$export(module.exports, "ClassificationEditModal", () => $5cd13874f5033207$export$d7e008c8afea1e79);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $ekolh = parcelRequire("ekolh");
var $9ot3w = parcelRequire("9ot3w");
var $d8eRd = parcelRequire("d8eRd");
var $6xdDU = parcelRequire("6xdDU");

var $9wGTI = parcelRequire("9wGTI");

var $dIouf = parcelRequire("dIouf");

var $40pD8 = parcelRequire("40pD8");

var $fGQzQ = parcelRequire("fGQzQ");

var $l4l51 = parcelRequire("l4l51");

var $earLp = parcelRequire("earLp");

var $8KSlr = parcelRequire("8KSlr");

var $93WhG = parcelRequire("93WhG");
const $5cd13874f5033207$export$d7e008c8afea1e79 = ({ contentId: contentId, spaceKey: spaceKey, contentClassificationMetadata: contentClassificationMetadata })=>{
    const { isClassificationModalOpen: isClassificationModalOpen } = (0, $40pD8.useClassificationModalContext)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: classification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, // TODO: remove these two below, once fg('dlp_cc-minimize-classifications-queries) is removed
    spaceClassification: spaceClassificationOld, getClassificationLevelFromId: getClassificationLevelFromIdOld } = contentClassificationMetadata;
    const intl = (0, $dBxQj.default)();
    const { defaultClassificationOption: defaultOptionFromHook, error: classificationOptionError } = (0, $l4l51.useComputeDefaultClassificationDropdownOption)({
        getClassificationLevelFromId: getClassificationLevelFromIdOld,
        spaceDefaultClassificationLevel: spaceClassificationOld,
        skipQuery: (0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries')
    });
    const defaultClassificationOption = (0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries') ? undefined : defaultOptionFromHook;
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? classification : defaultClassificationOption;
    const onEditSubmit = (0, $gwFzn.useCallback)((classificationOption)=>{
        handleSubmit(classificationOption);
        setIsClassificationModalOpen(false);
    }, [
        handleSubmit,
        setIsClassificationModalOpen
    ]);
    const onEditCancel = (0, $gwFzn.useCallback)(()=>{
        setIsClassificationModalOpen(false);
    }, [
        setIsClassificationModalOpen
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isClassificationModalOpen) trackEditPopupViewed((0, $earLp.ActionSubjectId).GENERIC_DATA_CLASSIFICATION_MODAL_POPUP);
    }, [
        isClassificationModalOpen,
        trackEditPopupViewed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, isClassificationModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        onClose: ()=>setIsClassificationModalOpen(false),
        width: "330px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8eRd.default), null, intl.formatMessage((0, $93WhG.sharedMessages).classifyContent))), classificationOptionError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: classificationOptionError
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8KSlr.ClassificationEditViewPopup), {
        onEditSubmit: onEditSubmit,
        onEditCancel: onEditCancel,
        selectedOption: defaultSelectedEditOption ?? undefined,
        defaultOption: defaultClassificationOption,
        spaceKey: spaceKey,
        shouldShowHeading: false
    })));
};

});

parcelRegister("40pD8", function(module, exports) {

$parcel$export(module.exports, "ClassificationModalContextProvider", () => $512bc11813ea6463$export$dd63fef46bf243c2);
$parcel$export(module.exports, "useClassificationModalContext", () => $512bc11813ea6463$export$3e27c86e4ac00950);
$parcel$export(module.exports, "useClassificationModalDispatchContext", () => $512bc11813ea6463$export$6c62639a7ca504f5);

var $gwFzn = parcelRequire("gwFzn");
const $512bc11813ea6463$var$ClassificationModalContext = /*#__PURE__*/ (0, $gwFzn.createContext)({
    isClassificationModalOpen: false
});
$512bc11813ea6463$var$ClassificationModalContext.displayName = 'ClassificationModalContext';
const $512bc11813ea6463$export$ed3f7b1d90b3e679 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    setIsClassificationModalOpen: ()=>{}
});
$512bc11813ea6463$export$ed3f7b1d90b3e679.displayName = 'ClassificationModalDispatchContext';
const $512bc11813ea6463$export$dd63fef46bf243c2 = ({ children: children })=>{
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $gwFzn.useState)(false);
    const contextValue = (0, $gwFzn.useMemo)(()=>({
            isClassificationModalOpen: isClassificationModalOpen
        }), [
        isClassificationModalOpen
    ]);
    const dispatchContextValue = (0, $gwFzn.useMemo)(()=>({
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        }), [
        setIsClassificationModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
        value: dispatchContextValue
    }, children));
};
const $512bc11813ea6463$export$3e27c86e4ac00950 = ()=>{
    return (0, $gwFzn.useContext)($512bc11813ea6463$var$ClassificationModalContext);
};
const $512bc11813ea6463$export$6c62639a7ca504f5 = ()=>{
    return (0, $gwFzn.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
};

});

parcelRegister("8KSlr", function(module, exports) {

$parcel$export(module.exports, "ClassificationEditViewPopup", () => $45d21f3c639a715a$export$df1a42b01f6d3dd1);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $cd3ua = parcelRequire("cd3ua");

var $9wGTI = parcelRequire("9wGTI");

var $cwD0R = parcelRequire("cwD0R");

var $huR5x = parcelRequire("huR5x");

var $l4l51 = parcelRequire("l4l51");

var $93WhG = parcelRequire("93WhG");
const $45d21f3c639a715a$export$df1a42b01f6d3dd1 = ({ spaceKey: spaceKey, selectedOption: selectedOptionProp, defaultOption: defaultOptionProp, onEditCancel: onEditCancel, onEditSubmit: onEditSubmit, loading: loading = false, shouldShowHeading: shouldShowHeading = true })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { defaultClassification: spaceDefaultClassification, classificationLevels: classificationLevels, getClassificationLevelFromId: getClassificationLevelFromId, expectedError: expectedError, loading: spaceAndDefaultLoading } = (0, $cwD0R.useDefaultAndSpaceClassificationLevels)({
        spaceKey: spaceKey,
        shouldPreloadData: (0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries')
    });
    const { defaultClassificationOption: defaultClassificationOptionNew, error: defaultClassificationError, loading: orgDefaultLoading } = (0, $l4l51.useComputeDefaultClassificationDropdownOption)({
        spaceDefaultClassificationLevel: spaceDefaultClassification,
        getClassificationLevelFromId: getClassificationLevelFromId,
        skipQuery: !(0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries') // default will come from prop otherwise
    });
    const defaultOption = (0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries') ? defaultClassificationOptionNew : defaultOptionProp;
    const selectedOption = (0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries') ? selectedOptionProp || defaultOption : selectedOptionProp;
    let allClassificationLevels = [
        ...(0, $huR5x.getAllClassificationLevels)(classificationLevels)
    ];
    // NOTE: Realistically, in either flag state it should not be undefined —
    // Remove this typehack with when fg('dlp_cc-minimize-classifications-queries') removed
    if (defaultOption) allClassificationLevels = [
        ...allClassificationLevels,
        defaultOption
    ];
    const hasError = !!expectedError || !!defaultClassificationError;
    // Note: If we do not re-render the EditPopup after loading is completed,
    // the selectedOption may not be correct, as its only used in EditPopup
    // for the initial useState value; it is not a controlled value.
    const combinedLoadingCondition = loading || spaceAndDefaultLoading || orgDefaultLoading;
    if (combinedLoadingCondition && (0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cd3ua.EditPopup), {
        options: allClassificationLevels,
        selectedOption: selectedOption,
        onEditCancel: onEditCancel,
        onEditSubmit: onEditSubmit,
        loading: combinedLoadingCondition,
        errorMessage: hasError ? formatMessage((0, $93WhG.sharedMessages).fetchErrorTextPrimary) : undefined,
        shouldShowHeading: shouldShowHeading
    });
};

});

parcelRegister("cd3ua", function(module, exports) {

$parcel$export(module.exports, "EditPopup", () => $0a0eca5e529a383f$export$646a7c8e1b78fd89);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");

var $7hXDW = parcelRequire("7hXDW");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $lRogx = parcelRequire("lRogx");

var $1HYxw = parcelRequire("1HYxw");
const $0a0eca5e529a383f$var$popupContainerStyles = (0, $ecnYn.xcss)({
    width: '330px',
    padding: 'space.250'
});
const $0a0eca5e529a383f$export$646a7c8e1b78fd89 = ({ options: options, selectedOption: selectedOption, customHeading: customHeading, loading: loading = false, errorMessage: errorMessage, onEditCancel: onEditCancel, onEditSubmit: onEditSubmit, onChange: onChange, isDisabled: isDisabled = false, menuShouldScrollIntoView: menuShouldScrollIntoView = false, shouldShowHeading: // default to false as it is a popup, disable scroll behavor of select in popup https://product-fabric.atlassian.net/browse/DSP-22142,
shouldShowHeading = true // default to true
 })=>{
    const intl = (0, $dBxQj.default)();
    // This keeps track of the selected classification in the dropdown. selectedOption is the classification that was selected before the edit popup was opened.
    const [selectedClassification, setSelectedClassification] = (0, $gwFzn.useState)(selectedOption);
    const onDropdownChange = (selected)=>{
        setSelectedClassification(selected);
    };
    const onUpdateClick = ()=>{
        selectedClassification && onEditSubmit && onEditSubmit(selectedClassification);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $0a0eca5e529a383f$var$popupContainerStyles,
        role: "dialog",
        "aria-labelledby": "data-classification-edit-content-label",
        "aria-modal": "true",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
            space: "space.200",
            children: [
                shouldShowHeading && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                    size: "small",
                    id: "data-classification-edit-content-label",
                    children: customHeading || intl.formatMessage((0, $1HYxw.messages).classifyContent)
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lRogx.DataClassificationDropdown), {
                    label: intl.formatMessage((0, $1HYxw.messages).selectClassification),
                    options: options,
                    value: selectedClassification,
                    onChange: onDropdownChange,
                    onInputChange: onChange,
                    errorMessage: errorMessage,
                    isDisabled: isDisabled,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
                    justifyContent: "end",
                    gap: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                            onClick: onEditCancel,
                            appearance: "subtle",
                            children: intl.formatMessage((0, $1HYxw.messages).cancelButton)
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                            isLoading: loading,
                            onClick: onUpdateClick,
                            appearance: "primary",
                            isDisabled: !selectedClassification || Boolean(errorMessage) || isDisabled,
                            children: intl.formatMessage((0, $1HYxw.messages).updateButton)
                        })
                    ]
                })
            ]
        })
    });
};

});

parcelRegister("cwD0R", function(module, exports) {

$parcel$export(module.exports, "useDefaultAndSpaceClassificationLevels", () => $8cba0a28a1fd2043$export$3601b6f432c64987);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $aMcHK = parcelRequire("aMcHK");

var $7Sm4c = parcelRequire("7Sm4c");

var $kknEZ = parcelRequire("kknEZ");

var $2Pqlt = parcelRequire("2Pqlt");

var $1cYlh = parcelRequire("1cYlh");
const $8cba0a28a1fd2043$export$3601b6f432c64987 = ({ spaceKey: spaceKey, isAdmin: isAdmin, setClassificationsEnabledForSpace: setClassificationsEnabledForSpace, skipQuery: skipQuery = false, shouldPreloadData: shouldPreloadData = false })=>{
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $2Pqlt.DefaultAndSpaceClassificationLevelsQuery), {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey || isAdmin === false || skipQuery,
        errorPolicy: 'all',
        fetchPolicy: shouldPreloadData ? 'cache-first' : 'network-only'
    });
    // If there was a 404 status error,
    // then classifications are not enabled for that space
    const isEnabled = !error || error && !error?.message.includes('Feature is disabled');
    if (setClassificationsEnabledForSpace) setClassificationsEnabledForSpace(isEnabled);
    // If no default classification is set for the space, then we want
    // to send a fallback No Classification option instead of throwing an error
    const noDefaultClassification = error?.message.includes('No default classification set for space with ID');
    const expectedError = error && !noDefaultClassification && (0, $aMcHK.isStatusCodeError)(error, '404') || (0, $aMcHK.isStatusCodeError)(error, '500') || (0, $aMcHK.isStatusCodeError)(error, '400');
    // Mark error as handled if 1) feature is not enabled, 2) there is no default
    // classification set, or 3) there was another kind of expected error
    if (!isEnabled || noDefaultClassification || expectedError) (0, $7Sm4c.markErrorAsHandled)(error);
    // Classification levels to display - ordered, and filtered by status
    // (to only display published levels)
    const classificationLevels = (0, $gwFzn.useMemo)(()=>loading || expectedError || !data ? [] : data?.['classificationLevels'].filter((classification)=>classification.status === (0, $kknEZ.Status).PUBLISHED).sort((a, b)=>a.order - b.order), [
        loading,
        expectedError,
        data
    ]);
    const defaultId = noDefaultClassification ? (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) : data?.space?.['defaultClassificationLevelId'];
    const [unfilteredClassificationId, setUnfilteredClassificationId] = (0, $gwFzn.useState)(defaultId);
    if (!unfilteredClassificationId && defaultId) setUnfilteredClassificationId(defaultId);
    const spaceName = data?.space?.name;
    const totalCurrentPages = data?.space?.metadata.totalCurrentPages;
    // Find default classification from unfiltered list,
    // in case classification is not published
    const defaultClassification = noDefaultClassification ? (0, $1cYlh.NO_CLASSIFICATION_OPTION) : data?.['classificationLevels']?.find((level)=>level.id === unfilteredClassificationId);
    const getClassificationLevelFromId = (0, $gwFzn.useCallback)((classificationLevelId)=>{
        return classificationLevels?.find((level)=>level.id === classificationLevelId);
    }, [
        classificationLevels
    ]);
    return {
        classificationLevels: classificationLevels,
        defaultClassification: defaultClassification,
        defaultId: defaultId,
        loading: loading,
        isEnabled: isEnabled,
        expectedError: expectedError,
        spaceName: spaceName,
        totalCurrentPages: totalCurrentPages,
        setUnfilteredClassificationId: setUnfilteredClassificationId,
        getClassificationLevelFromId: getClassificationLevelFromId
    };
};

});

parcelRegister("huR5x", function(module, exports) {

$parcel$export(module.exports, "getAllClassificationLevels", () => $bc2f28c1af54773b$export$14c071c2473cc4e7);
const $bc2f28c1af54773b$export$14c071c2473cc4e7 = (classificationLevels)=>{
    // Data classification dropdown in edit popup accepts definition property for displaying descriptions per classification
    const classificationLevelsWithDefinitions = classificationLevels.map((level)=>({
            ...level,
            definition: level.description
        }));
    return [
        ...classificationLevelsWithDefinitions
    ];
};

});


//# sourceMappingURL=ClassificationEditModal.661ae626.js.map
